<div class="card">
  <div class="card-header text-header">
    <div class="row">
      <div class="col-lg-3">
        <span class="fa fa-list"></span>
        Audit Trails
      </div>
      <div class="col-md-9">
        <div class="pull-right" style="right: 20px;">
          <span class="text-capitalize pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
            <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue float-right">
              Filters <span class="caret"></span>
            </span>
            <div class="row" style="margin-left: 0; margin-right: 0;">
              <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu col-md-12 p-3" role="menu"
                aria-labelledby="button-triggers-manual">
                <app-audit-trail-filters (OnFilter)="OnFilter($event)"></app-audit-trail-filters>
              </div>
            </div>
          </span>
        </div>
        <div class="pull-right" style="right: 20px;">
          <span class="text-capitalize pl-3 cursor-pointer text-blue" (click)="downloadReport()">
            <span class="fa fa-download"></span> Export Report
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row mt-2">
      <div class="col-lg-12">
        <div class="text-blue" *ngIf="(auditTrailList && (auditTrailList.length>0))">
          {{endIndex}} out of {{totalCount}}
        </div>
      </div>
    </div>
    <div class="table-responsive box-shadow setHeight table-cont mt-2" #tableContent>
      <table class="table table-fixed table-hover mb-0">
        <thead>
          <tr>
            <th class="pointer col-lg-2 mx-width-16pr" (click)="sortAuditTrail('CreatedDateTime')">
              Date
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (auditTrailDto.SortKey === 'CreatedDateTime' && !auditTrailDto.IsDesc),
                'fa-sort-amount-desc': (auditTrailDto.SortKey === 'CreatedDateTime' && auditTrailDto.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="pointer col-lg-2 mx-width-16pr" (click)="sortAuditTrail('Division')">
              Division
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (auditTrailDto.SortKey === 'Division' && !auditTrailDto.IsDesc),
                'fa-sort-amount-desc': (auditTrailDto.SortKey === 'Division' && auditTrailDto.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="pointer col-lg-2 mx-width-14pr" (click)="sortAuditTrail('UserName')">
              User
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (auditTrailDto.SortKey === 'UserName' && !auditTrailDto.IsDesc),
                'fa-sort-amount-desc': (auditTrailDto.SortKey === 'UserName' && auditTrailDto.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="pointer col-lg-2 mx-width-16pr" (click)="sortAuditTrail('Screen')">
              Screen
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (auditTrailDto.SortKey === 'Screen' && !auditTrailDto.IsDesc),
                'fa-sort-amount-desc': (auditTrailDto.SortKey === 'Screen' && auditTrailDto.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="pointer col-lg-2 mx-width-16pr" (click)="sortAuditTrail('Activity')">
              Function
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (auditTrailDto.SortKey === 'Activity' && !auditTrailDto.IsDesc),
                'fa-sort-amount-desc': (auditTrailDto.SortKey === 'Activity' && auditTrailDto.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
            <th class="pointer col-lg-2 mx-width-22pr" (click)="sortAuditTrail('Action')">
              Action
              <i class="fa" [ngClass]="{'fa-sort-amount-asc': (auditTrailDto.SortKey === 'Action' && !auditTrailDto.IsDesc),
                'fa-sort-amount-desc': (auditTrailDto.SortKey === 'Action' && auditTrailDto.IsDesc) }"
                aria-hidden="true">
              </i>
            </th>
          </tr>
        </thead>
        <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
        <tbody style="max-height: 660px;" [style.max-height.px]="myInnerHeight">
          <cdk-virtual-scroll-viewport class="list-container list-group audit-trail-div" itemSize="20"
            (scrolledIndexChange)="eventHandler($event)" [style.height.px]="myInnerHeight" *ngIf="auditTrailList">
            <div *cdkVirtualFor="let item of auditTrailList; let i = index">
              <tr>
                <td class="col-lg-2 mx-width-16pr">{{item.createdDateTime | date:'dd-MMM-yyyy HH:mm' }}</td>
                <td class="col-lg-2 mx-width-16pr">{{item.division}}</td>
                <td class="col-lg-2 mx-width-14pr">{{item.userName}}</td>
                <td class="col-lg-2 mx-width-16pr">{{item.screen}}</td>
                <td class="col-lg-2 mx-width-16pr tbl-td-scroll">{{item.activity}}</td>
                <td class="col-lg-2 mx-width-22pr" [innerHTML]="item.action"></td>
              </tr>
            </div>
          </cdk-virtual-scroll-viewport>
        </tbody>
      </table>
    </div>
  </div>
</div>
